/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export const isTargetSearched = (
  target: (string | null | undefined) | (string | null | undefined)[],
  searchInput: string
) => {
  const targetArray = Array.isArray(target) ? target : [target];

  return targetArray.some((targetItem) =>
    (targetItem ?? '').toLowerCase().includes(searchInput.trim().toLowerCase())
  );
};
